import {
    gql,
  } from '@apollo/client';
  import GraphQlService from './graphql';

  class externalIntegrationConfigGraphql extends GraphQlService {
    async getExternalIntegrationConfigs() {
      return this.client
        .query({
          query: gql`
            query {
                getAllConfig {
                    id
                    accountId
                    timer
                    runOnce
                    updateMethod
                    configJson
                    active
                    account {
                      id
                      name
                    }
                }
            }
          `,
        })
        .then((result) => result?.data?.getAllConfig);
    }

    // `pagination` optional — omitted entirely, the backend returns the
    // full set in one call (same convention as
    // UsersGraphqlInstance.getAllUsers). `active` is the one filter this
    // table has (the Status column's Active/Deactivated choice);
    // undefined/null means no filter.
    async getExternalIntegrationConfigsPage(pagination = {}) {
      const { limit, offset, sortField, sortOrder, active } = pagination;
      return this.client
        .query({
          query: gql`
            query GetConfigPage(
              $limit: Float
              $offset: Float
              $sortField: String
              $sortOrder: String
              $active: Boolean
            ) {
              getConfigPage(
                limit: $limit
                offset: $offset
                sortField: $sortField
                sortOrder: $sortOrder
                active: $active
              ) {
                total
                items {
                  id
                  accountId
                  timer
                  runOnce
                  updateMethod
                  configJson
                  active
                  account {
                    id
                    name
                  }
                }
              }
            }
          `,
          variables: {
            limit: limit ?? null,
            offset: offset ?? null,
            sortField: sortField ?? null,
            sortOrder: sortOrder ?? null,
            active: active ?? null,
          },
          fetchPolicy: "no-cache",
        })
        .then((result) => result?.data?.getConfigPage);
    }

    async createExternalIntegrationsConfig(data) {
      return this.client
        .mutate({
          mutation: gql`
          mutation {
            createExternalIntegrationsConfig(
              createExternalIntegrationsConfig: {
                accountId: "${data.accountId}",
                timer: "${data.timer}",
                runOnce: ${data.runOnce},
                updateMethod: "${data.updateMethod}",
                configJson: """${data.configJson}"""
              }
            ){
              id
            }
          }
        `,
      })
      .then((result) => result?.data?.createExternalIntegrationsConfig);
    }
    async updateStatusConfig(id, active) {
      return this.client
        .mutate({
          mutation: gql`
          mutation {
            updateStatusConfig(
              updateStatusConfig: {
                id:"${id}"
                active: ${active}
              }
            ){
              id
              accountId
              active
              timer
              runOnce
              updateMethod
              configJson
              account{
                id
                name
              }
            }
          }
        `,
      })
      .then((result) => result?.data?.updateStatusConfig);
    }
    async updateExternalIntegrationsConfig(id, data) {
      return this.client
        .mutate({
          mutation: gql`
          mutation {
            updateExternalIntegrationsConfig(
              updateExternalIntegrationsConfig: {
                id:"${id}"
                accountId: "${data.accountId}",
                timer: "${data.timer}",
                runOnce: ${data.runOnce},
                updateMethod: "${data.updateMethod}",
                configJson: """${data.configJson}"""
              }
            ){
              id
              accountId
              active
              timer
              runOnce
              updateMethod
              configJson
              account{
                id
                name
              }
            }
          }
        `,
      })
      .then((result) => result?.data?.updateExternalIntegrationsConfig);
    }
}
const externalIntegrationConfigService = new externalIntegrationConfigGraphql();
export default externalIntegrationConfigService; 
